
import React, {Component} from 'react';
import loadLocaleData, {getLanguageFromLocale} from '../../utils/loadLocale';
import {IntlProvider} from 'react-intl';
import {withTranslations} from '../translations/';
import {compose} from 'redux';
import {connect} from 'react-redux';

export class IntlWrapper extends Component {
    constructor(props) {
        super(props);
        loadLocaleData(props.locale);
    }

    render() {
        const {children, translations, locale} = this.props;
        const intlLocale = getLanguageFromLocale(locale);
        return (
            <IntlProvider
                locale={intlLocale}
                key={intlLocale}
                messages={translations}
            >
                {children}
            </IntlProvider>
        );
    }
}

const mapStateToProps = ({system: {locale = 'en_US'} = {}} = {}) => ({locale});
export default compose(withTranslations, connect(mapStateToProps))(IntlWrapper);



// WEBPACK FOOTER //
// ./src/universal/components/intl/intl-wrapper.js